define("shared/utils/search/determine-searched-words", ["exports", "later/utils/constants"], function (_exports, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/constants"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class determineSearchedWords
   * @extends Utils
   */

  /**
   *
   * @method determineSearchedWords
   * @param {String} queryText string containing words to be split
   *
   * @return {Array} Array of searched terms
   */

  const determineSearchedWords = queryText =>
  // Note: search for each separate word entered
  queryText.trim().split(' ').map(searchWord => searchWord.replace(_constants.ESCAPE_SEARCH_REGEX, _constants.ESCAPE_SEARCH_REPLACEMENT).toLowerCase()).filter(sanitizedSearchWord => sanitizedSearchWord.length > 0);
  var _default = _exports.default = determineSearchedWords;
});